/*eslint-disable no-unused-vars */
import { mapState, mapGetters, mapActions } from "vuex";
/*eslint-enable */

import moment from "moment";

export default {
  methods: {
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    formateDateTime(datetime) {
      return moment(datetime).format("YYYY-MM-DD HH:mm");
    },

    formateTime(time) {
      return moment(time, "HH:mm:ss").format("LT");
    },

    displayName(first, last, other) {
      let name = `${first} ${last}`;

      name = other ? `${first}, ${last}（${other}）` : name;

      return first || last ? name : "-";
    },

    displayI18nText(obj) {
      if (!obj) {
        return "";
      }

      return obj[this.$i18n.locale] || obj["en"];
    },

    jsonParse(value) {
      try {
        return JSON.parse(value);
      } catch (error) {
        return "**JSON Parse Error**";
      }
    },
    showPrice(string) {}
  }
};
